import { useEffect, useRef } from 'react';

export function useRefreshOnReturn(enabled: boolean, refresh: () => void | Promise<void>) {
  const refreshRef = useRef(refresh);
  const pending = useRef(false);
  refreshRef.current = refresh;

  useEffect(() => {
    const onReturn = () => {
      if (!enabled || document.visibilityState === 'hidden' || pending.current) return;
      pending.current = true;
      queueMicrotask(() => {
        if (document.visibilityState === 'hidden') { pending.current = false; return; }
        Promise.resolve(refreshRef.current()).finally(() => { pending.current = false; });
      });
    };
    window.addEventListener('focus', onReturn);
    document.addEventListener('visibilitychange', onReturn);
    return () => {
      window.removeEventListener('focus', onReturn);
      document.removeEventListener('visibilitychange', onReturn);
      pending.current = false;
    };
  }, [enabled]);
}
